import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/atendimento-enfermagem`

    return {
        create(queryParms) {
            return repository.get(`${baseUrl}/create?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        uploadImagem(params) {
            return repository.post(`${baseUrl}/upload-imagem`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}/destroy`)
        },
    }
}